import React, { useContext, useState } from 'react';
import ModalContext from '../../../context/ModalContext';
import AuthContext from '../../../context/AuthContext';
import { Button, CircularProgress } from '@mui/material';

const DeleteLeadModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const { lead, coupon } = modalDetails;
  const item = lead || coupon;
  const itemType = item?.type || (lead ? 'lead' : 'coupon');
  const isCoupon = itemType === 'coupon';
  const isPopin = itemType === 'popin';
  const hasPopinCoupon = isPopin && !!item?.coupon_id;
  const hasLivePopinContent = isPopin && (!!item?.live_coupon_id || item?.status !== 'draft');
  const itemLabel = isCoupon ? 'Coupon' : isPopin ? 'Pop-in' : 'Lead';

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleDelete = async () => {
    if (!item?.id) {
      console.error(`No ${itemLabel.toLowerCase()} ID provided`);
      return;
    }

    setLoading(true);

    try {
      const url = isPopin
        ? `${process.env.REACT_APP_API_URI}/v3/admin/popin/${item.id}`
        : `${process.env.REACT_APP_API_URI}/v3/leads/${item.id}${itemType ? `?type=${itemType}` : ''}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authCtx.token}`,
        },
      });

      const data = await response.json();

      if (data.status === 'success') {
        modalCtx.setPageUpdate({ page: 'CouponLeads', itemId: item.id });
        closeHandle();
      } else {
        console.error(`Failed to delete ${itemLabel.toLowerCase()}:`, data.error || data.message || 'Unknown error');
      }
    } catch (error) {
      console.error(`Error deleting ${itemLabel.toLowerCase()}:`, error);
    } finally {
      setLoading(false);
    }
  };

  const headerTitle = isPopin ? 'Delete Pop-in' : `Delete ${itemLabel}`;
  const actionLabel = isPopin ? 'Delete' : 'DELETE';
  const actionColor = '#dc3545';

  return (
    <div className="modal-container">
      <div className="modal-header">
        <h1>{headerTitle}</h1>
      </div>
      <div className="modal-body">
        {isPopin ? (
          <>
            <span>Are you sure you want to permanently delete this pop-in?</span><br />
            <span style={{ fontSize: '12px', color: '#555' }}>
              {hasPopinCoupon
                ? 'This will permanently delete the pop-in, its locations, linked draft coupon, and hard-delete the live company, coupons, and related company or coupon records.'
                : hasLivePopinContent
                  ? 'This will permanently delete the pop-in, its locations, and hard-delete the live company and its locations.'
                  : 'This action will permanently delete the pop-in and its locations.'}
            </span>
          </>
        ) : (
          <>
            <span>Are you sure you want to delete this {itemLabel.toLowerCase()}?</span><br />
            <strong>NOTE: This action cannot be undone</strong>
          </>
        )}
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}>CANCEL</Button>
        <Button onClick={handleDelete} disabled={loading} style={{ backgroundColor: actionColor, color: '#fff' }}>
          {loading ? <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} /> : actionLabel}
        </Button>
      </div>
    </div>
  );
};

export default DeleteLeadModal;
